module.exports = __webpack_public_path__ + "img/v4.82473150.png";